import React from 'react';
import './home.css';


export function Home() {
    return (
        <div className='home'> 
            <div className ='home-div'>          
            <span >
                <h1>Hi, I am &nbsp;</h1>
            <h1 className = 'home-text'>
                 Ramneek Marwaha 
            </h1>
            </span>
            <span className='sub-text-home'>
            <p>I am a frontend web developer. 
            I can provide clean code and pixel perfect design. 
            I also make website more & more interactive with web animations.
            </p>
            </span>
            </div>
        </div>
    )
}